import { render, staticRenderFns } from "./Practical.vue?vue&type=template&id=08ad631b&scoped=true&"
import script from "./Practical.vue?vue&type=script&lang=js&"
export * from "./Practical.vue?vue&type=script&lang=js&"
import style0 from "./Practical.vue?vue&type=style&index=0&id=08ad631b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad631b",
  null
  
)

export default component.exports